export const LOGIN = 'LOGIN';
export const UPDATE_STATUS = 'UPDATE_STATUS';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const BRAND_VIEW = 'BRAND_VIEW';